module.exports = __webpack_public_path__ + "static/img/about_xuanyuan_bg1@2x.4e6c557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_xuanyuan_bg1@2x.png
// module id = GyoN
// module chunks = 32